module.exports = __webpack_public_path__ + "media/images/sindma/hero-teclado-3c53b8605f2a3a4989d079e7961fd4e3.png";